export function applyRetryInterceptor(instance, maxRetries = 3) {
    const retryableErrors = [
        'ERR_HTTP2_PROTOCOL_ERROR',
        'ERR_HTTP2',
        'ECONNRESET',
        'ECONNABORTED',
        'ETIMEDOUT',
        'ENOTFOUND',
        'EAI_AGAIN',
        'EPIPE',
        'EHOSTUNREACH',
        'EADDRNOTAVAIL',
        'EHOSTDOWN',
        'ENETUNREACH',
        'EWOULDBLOCK'
    ];

    instance.interceptors.response.use(
        response => response,
        async error => {
            const config = error.config;

            if (!config || config.__retryDisabled) return Promise.reject(error);

            config.__retryCount = config.__retryCount || 0;

            const code = error.code || '';
            const message = (error.message || '').toUpperCase();

            const isRetryable =
                !error.response ||
                retryableErrors.includes(code) ||
                retryableErrors.some(err => message.includes(err));

            if (isRetryable && config.__retryCount < maxRetries) {
                config.__retryCount += 1;
                console.warn(`Retrying request (${config.__retryCount}/${maxRetries})...`);
                await new Promise(resolve => setTimeout(resolve, 1000 * config.__retryCount));
                return instance(config);
            }

            if (config.__retryCount >= maxRetries) {
                console.error('Reintentos agotados. Mostrando confirmación antes de recargar.');
                // Opcional: remover el almacenamiento si existía
                localStorage.removeItem('lastFailedRequest');
                return Promise.reject(error);
                /*
                const requestData = {
                    url: config.url,
                    method: config.method,
                    data: config.data,
                    params: config.params,
                    headers: config.headers
                };
                try {
                    localStorage.setItem('lastFailedRequest', JSON.stringify(requestData));
                } catch (e) {
                    console.warn('No se pudo guardar los datos fallidos en localStorage', e);
                }

                const confirmMessage = `An unexpected error occurred and we could not recover after several attempts.
Reloading the system may solve the problem.
Do you want to reload now?

(ES) Ha ocurrido un error inesperado y no pudimos recuperarlo tras varios intentos.
Recargar el sistema podría solucionar el problema.
¿Desea recargar ahora?`;

                if (window.confirm(confirmMessage)) {
                    window.location.reload();
                }*/
            }

            return Promise.reject(error);
        }
    );
}
